import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class EeaOutputProjectPwcResultsPondReservoirColDef {

  public getPondReservoirColumnsDefinition(isProjectOwnershipValid: boolean){
    return [
      {
        headerName: 'EEA SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 95,
        sortable: true,
        field: 'EeaSmeSelection',
        hide: !isProjectOwnershipValid,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        },
      },
      {
        headerName: 'Run ID',
        field: 'RunId',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Child Level',
        field: 'ChildLevel',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Compound',
        field: 'Compound',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Dataset',
        field: 'Dataset',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Application Scheme',
        field: 'ApplicationScheme',
        width: 260,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Crop',
        field: 'Crop',
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Region',
        field: 'Region',
        width: 85,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Waterbody',
        field: 'Waterbody',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: '1-d avg',
        field: 'OneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '365-d avg',
        field: 'OneYearAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Total avg',
        field: 'TotalAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '4-d avg',
        field: 'FourDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '21-d avg',
        field: 'TwentyOneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '60-d avg',
        field: 'SixtyDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'B 1-day',
        field: 'BOneDay',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'B 21-d avg',
        field: 'BTwentyOneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Off-Field',
        field: 'OffField',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Runoff Frac',
        field: 'RunOffFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Erosn Frac',
        field: 'ErosnFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Drift Frac',
        field: 'DriftFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col washout',
        field: 'ColWashout',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col metab',
        field: 'ColMetab',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col hydro',
        field: 'ColHydro',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col photo',
        field: 'ColPhoto',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col volat',
        field: 'ColVolat',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col total',
        field: 'ColTotal',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben sed rem',
        field: 'BenSedRem',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben metab',
        field: 'BenMetab',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben hydro',
        field: 'BenHydro',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben total',
        field: 'BenTotal',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'gw_peak',
        field: 'GwPeak',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'post_bt_avg',
        field: 'PostBtAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'throughput',
        field: 'Throughput',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'sim_avg_gw',
        field: 'SimAvgGw',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Run Information',
        field: 'RunInformation',
        width: 350,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      }
    ];
  }

  public getTpezColumnsDefinition(isProjectOwnershipValid: boolean){

    return [
      {
        headerName: 'EEA SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 95,
        sortable: true,
        field: 'EeaSmeSelection',
        hide: !isProjectOwnershipValid,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        }
      },
      {
        headerName: 'Run ID',
        field: 'RunId',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Child Level',
        field: 'ChildLevel',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Compound',
        field: 'Compound',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Dataset',
        field: 'Dataset',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Application Scheme',
        field: 'ApplicationScheme',
        width: 260,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Crop',
        field: 'Crop',
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Region',
        field: 'Region',
        width: 85,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'TPEZ (kg/ha)',
        field: 'TpezKgHa',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Run Information',
        field: 'RunInformation',
        width: 420,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      }
    ];
  }

  public getWpezColumnsDefinition(isProjectOwnershipValid: boolean){
    return [
      {
        headerName: 'EEA SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 95,
        sortable: true,
        field: 'EeaSmeSelection',
        hide: !isProjectOwnershipValid,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        }
      },
      {
        headerName: 'Run ID',
        field: 'RunId',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Child Level',
        field: 'ChildLevel',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Compound',
        field: 'Compound',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Dataset',
        field: 'Dataset',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Application Scheme',
        field: 'ApplicationScheme',
        width: 285,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Crop',
        field: 'Crop',
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Region',
        field: 'Region',
        width: 85,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: '1-d avg',
        field: 'OneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '365-d avg',
        field: 'OneYearAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Total avg',
        field: 'TotalAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '4-d avg',
        field: 'FourDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '21-d avg',
        field: 'TwentyOneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: '60-d avg',
        field: 'SixtyDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'B 1-day',
        field: 'BOneDay',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'B 21-d avg',
        field: 'BTwentyOneDayAvg',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Off-Field',
        field: 'OffField',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Runoff Frac',
        field: 'RunOffFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Erosn Frac',
        field: 'ErosnFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Drift Frac',
        field: 'DriftFrac',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col washout',
        field: 'ColWashout',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col metab',
        field: 'ColMetab',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col hydro',
        field: 'ColHydro',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col photo',
        field: 'ColPhoto',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col volat',
        field: 'ColVolat',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'col total',
        field: 'ColTotal',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben sed rem',
        field: 'BenSedRem',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben metab',
        field: 'BenMetab',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben hydro',
        field: 'BenHydro',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'ben total',
        field: 'BenTotal',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'total_out(lb/A)    ',
        field: 'TotalOutLbA',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Run Information',
        field: 'RunInformation',
        width: 350,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      }
    ];
  }

  public getInputsColumnsDefinition(){
    return [
      {
        headerName: 'Run ID',
        field: 'runId',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Dataset',
        field: 'dataset',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Child Level',
        field: 'childLevel',
        width: 110,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Compound',
        field: 'compound',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Application Scheme',
        field: 'applicationScheme',
        width: 260,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Crop',
        field: 'crop',
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Region',
        field: 'region',
        width: 85,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false,
        pinned: true
      },
      {
        headerName: 'Sorption',
        field: 'sorption',
        width: 93,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Water Column Halflife',
        field: 'waterColumnHalflife',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Water Reference Temperature',
        field: 'waterReferenceTemperature',
        width: 130,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Benthic Halflife',
        field: 'benthicHalflife',
        width: 90,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Benthic Reference Temperature',
        field: 'benthicReferenceTemperature',
        width: 137,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Aqueous Photolysis Halflife',
        field: 'aqueousPhotolysisHalflife',
        width: 138,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Photolysis Reference Latitude',
        field: 'photolysisReferenceLatitude',
        width: 141,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Hydrolysis Halflife',
        field: 'hydrolysisHalflife',
        width: 102,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Soil Halflife',
        field: 'soilHalflife',
        width: 88,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Soil Reference Temperature',
        field: 'soilReferenceTemperature',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Foliar Halflife',
        field: 'foliarHalflife',
        width: 88,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Molecular Weight',
        field: 'molecularWeight',
        width: 100,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Vapor Pressure',
        field: 'vaporPressure',
        width: 93,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Solubility',
        field: 'solubility',
        width: 98,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: "Henry's Coefficient",
        field: 'henrysCoefficient',
        width: 106,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Air Diffusion Coefficient',
        field: 'airDiffusionCoefficient',
        width: 113,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Heat Of Henry',
        field: 'heatOfHenry',
        width: 90,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Foliar Washoff',
        field: 'foliarWashoff',
        width: 93,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Is Kd',
        field: 'isKd',
        width: 75,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Water Column Daughter',
        field: 'molesWaterColumnDaughter',
        width: 136,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Water Column Granddaugther',
        field: 'molesWaterColumnGranddaugther',
        width: 151,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Benthic Daugther',
        field: 'molesBenthicDaugther',
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Benthic Granddaughter',
        field: 'molesBenthicGranddaughter',
        width: 119,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Aqueous Photolysis Daugther',
        field: 'molesAqueousPhotolysisDaugther',
        width: 148,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Aqueous Photolysis Grandaugther',
        field: 'molesAqueousPhotolysisGrandaugther',
        width: 169,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Hydrolysis Halflife Daugther',
        field: 'molesHydrolysisHalflifeDaugther',
        width: 134,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Hydrolysis Halflife Granddaugther',
        field: 'molesHydrolysisHalflifeGranddaugther',
        width: 162,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Soil Halflife Daugther',
        field: 'molesSoilHalflifeDaugther',
        width: 134,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Soil Halflife Granddaugther',
        field: 'molesSoilHalflifeGranddaugther',
        width: 138,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Foliar Halflife Daugther',
        field: 'molesFoliarHalflifeDaugther',
        width: 134,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Moles Foliar Halflife Granddaugther',
        field: 'molesFoliarHalflifeGranddaugther',
        width: 147,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Simluation Types',
        field: 'simluationTypes',
        width: 103,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Use Spray Driff',
        field: 'useSprayDriff',
        width: 99,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Number Of Apllications',
        field: 'numberOfApllications',
        width: 108,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Date Type',
        field: 'datetype',
        width: 100,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Crop Event',
        field: 'cropEvent',
        width: 105,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Use Application Window',
        field: 'useApplicationWindow',
        width: 126,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Window Days To Windows Days',
        field: 'windowDaysToWindowsDays',
        width: 131,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Step Days To Step Days',
        field: 'stepDaysToStepDays',
        width: 112,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Adjust Application Dates If Raining',
        field: 'adjustApplicationDatesIfRaining',
        width: 140,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Intolerable Rain',
        field: 'intolerableRain',
        width: 104,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Intolerable Rain Window',
        field: 'intolerableRainWindow',
        width: 115,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Optimum Application Window',
        field: 'optimumApplicationWindow',
        width: 149,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Minimum Days Between Applications',
        field: 'minimumDaysBetweenApplications',
        width: 154,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Application Number',
        field: 'applicationNumber',
        width: 107,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Rate',
        field: 'rate',
        width: 74,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Application Date',
        field: 'applicationDate',
        width: 107,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Days',
        field: 'days',
        width: 75,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Application Method',
        field: 'applicationMethod',
        width: 107,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Depth',
        field: 'depth',
        width: 81,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Split',
        field: 'split',
        width: 74,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Drift Type',
        field: 'driftType',
        width: 75,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Drift Buffer',
        field: 'driftBuffer',
        width: 82,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Period',
        field: 'Period',
        width: 83,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
      {
        headerName: 'Lag',
        field: 'lag',
        width: 69,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        editable: false
      },
    ];
  }

}
